import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, breakpoints } from '@/styles'
import { PageTitle } from '@/features/Application/elements'
import { View as FinancialInfoView } from '@/features/Application/financial-info'
import { View as RoommateView } from '@/features/Application/roommates'
import { View as PetView } from '@/features/Application/pets'
import { View as EmergencyContactView } from '@/features/Application/emergency-contact'
import RenterView from './view-component'

const Wrapper = styled.div`
  position: relative;
  max-width: 900px;
  background: ${colors.grey96};
  border: 1px solid ${colors.grey88};
  border-radius: 0px 8px 8px 8px;
  padding: 45px 20px 20px;
  margin-top: 59px;

  @media screen and (max-width: ${breakpoints.desktopSmall}) {
    border-radius: 8px;
    margin-top: 10px;
    margin-bottom: 40px;
  }
`

const BasicInfo = ({ application, applicationLoading }) => {
  const { t } = useTranslation()
  return (
    <Wrapper id="basic-information">
      <PageTitle
        noMobileMarginTop
        title={t('b.application.view.tenancy_application.basic_info.title', 'Basic Information')}
      />
      <RenterView application={application} applicationLoading={applicationLoading} />
      <FinancialInfoView application={application} applicationLoading={applicationLoading} />
      <RoommateView application={application} applicationLoading={applicationLoading} />
      <PetView application={application} applicationLoading={applicationLoading} />
      <EmergencyContactView application={application} applicationLoading={applicationLoading} />
    </Wrapper>
  )
}

export default BasicInfo
